/**
 * ZEN ERP — Dashboard Satışlar/Alışlar Metrik Paneli
 * DashboardPage.jsx'ten çıkarıldı.
 */
import React, { useContext } from "react";
import { Receipt, ShoppingCart, RefreshCw, Package, TrendingUp } from "lucide-react";
import { UICtx } from "../../appContexts";
import { fmt } from "../../appUtils";

export function MetricCol({ color, icon: Icon, label, today, month, currency }) {
  const { tr } = useContext(UICtx);
  const colorMap = {
    emerald: "bg-emerald-500",
    sky:     "bg-sky-500",
    amber:   "bg-amber-500",
    purple:  "bg-purple-500",
    indigo:  "bg-indigo-500",
    rose:    "bg-rose-500",
  };
  return (
    <div className="rounded-xl bg-slate-50 dark:bg-[#0F1626] border border-slate-200/70 dark:border-[#22304A] p-3">
      <div className="flex items-center gap-2 mb-2">
        <div className={`w-6 h-6 rounded-md ${colorMap[color] || "bg-slate-500"} flex items-center justify-center text-white`}>
          <Icon className="w-3 h-3" />
        </div>
        <div className="text-[11px] font-semibold text-slate-600 dark:text-slate-300">{label}</div>
      </div>
      <div className="flex justify-between text-[11px]">
        <span className="text-slate-500 dark:text-slate-400">{tr("Bugün")}</span>
        <span className={`zen-mono font-semibold ${today ? "text-slate-800 dark:text-slate-100" : "text-slate-400/50 dark:text-slate-600"}`}>{fmt(today || 0, currency)}</span>
      </div>
      <div className="flex justify-between text-[11px] mt-1">
        <span className="text-slate-500 dark:text-slate-400">{tr("Bu Ay")}</span>
        <span className={`zen-mono font-bold ${month ? "text-emerald-500" : "text-slate-400/50 dark:text-slate-600"}`}>{fmt(month || 0, currency)}</span>
      </div>
    </div>
  );
}

export function DashboardMetrics({ summary }) {
  const { tr } = useContext(UICtx);
  const rev = summary.revenue || {};
  return (
    <div className="grid md:grid-cols-2 gap-4">
      {/* Satışlar - green */}
      <section className="rounded-2xl border border-emerald-500/40 bg-white dark:bg-[#131B2E] p-5 shadow-lg shadow-emerald-900/5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 rounded-md bg-emerald-500 flex items-center justify-center">
            <TrendingUp className="w-3.5 h-3.5 text-white" />
          </div>
          <h3 className="text-[13px] font-extrabold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">{tr("Satışlar")}</h3>
        </div>
        <div className="grid grid-cols-3 gap-3">
          <MetricCol color="emerald" icon={Receipt}     label={tr("Faturalar")}  today={rev.invoiceToday}  month={rev.invoiceMonth}  currency="EUR" />
          <MetricCol color="sky"     icon={ShoppingCart} label={tr("Siparişler")} today={rev.salesToday}    month={rev.salesMonth}    currency="EUR" />
          <MetricCol color="amber"   icon={RefreshCw}   label={tr("İadeler")}    today={rev.returnsToday}  month={rev.returnsMonth}  currency="EUR" />
        </div>
      </section>

      {/* Alışlar - purple */}
      <section className="rounded-2xl border border-purple-500/40 bg-white dark:bg-[#131B2E] p-5 shadow-lg shadow-purple-900/5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 rounded-md bg-purple-500 flex items-center justify-center">
            <Package className="w-3.5 h-3.5 text-white" />
          </div>
          <h3 className="text-[13px] font-extrabold uppercase tracking-wider text-purple-600 dark:text-purple-400">{tr("Alışlar")}</h3>
        </div>
        <div className="grid grid-cols-3 gap-3">
          <MetricCol color="purple" icon={Receipt}      label={tr("Faturalar")}  today={rev.purchaseInvoiceToday}  month={rev.purchaseInvoiceMonth}  currency="EUR" />
          <MetricCol color="indigo" icon={ShoppingCart} label={tr("Siparişler")} today={rev.purchaseOrdersToday}   month={rev.purchaseOrdersMonth}   currency="EUR" />
          <MetricCol color="rose"   icon={RefreshCw}   label={tr("İadeler")}    today={rev.purchaseReturnsToday}  month={rev.purchaseReturnsMonth}  currency="EUR" />
        </div>
      </section>
    </div>
  );
}
